export default __webpack_public_path__ + "static/AA081210_Citation_680-0141-05a_540x358-950927576d8c3fb33c54c729f5858cfe.jpg";